<template lang="pug">
  div.container-fluid.animated.fadeIn
    nav(aria-label="breadcrumb")
      b-breadcrumb
        b-breadcrumb-item
          router-link(to="/system")
            i.fa.fa-desktop
            span.ml-1 {{ $t("ui.system") }}
        b-breadcrumb-item
          router-link(to="/system/function")
            i.far.fa-file
            span.ml-1 {{ $tc("ui.functions", 2) }}
    div.row.mb-5
      div.col-md-12
        div.card
          div.card-header
            div.row
              div.col-md-12.mb-1
                div.form-row
                  div.col-sm-9.col-md-6.mb-1
                    b-input-group(size="sm")
                      b-input-group-text(slot="prepend")
                        i.icon-magnifier
                      DebounceInput(required autofocus type="text" v-model="functionSearch" :placeholder="$t('message.search_by_id_name')")
                  div.col-sm-3.col-md-1.mb-1
                    b-form-radio-group(
                      buttons
                      v-model="filterBy"
                      size="sm"
                      button-variant="outline-info"
                    )
                      b-form-radio(value="id") {{ $t("ui.id") }}
                      b-form-radio(value="name") {{ $t("ui.name") }}
              div.col-md-12
                b-button(v-b-modal.addFunction type="button" variant="primary" size="sm").mr-1
                  i.fa.fa-plus
                  span {{ $t("ui.combine.add_function") }}
          div.card-body.p-1.clusterize
            .clusterize-scroll
              table.tablex(style="width: auto;" v-columns-resizable)
                thead
                  tr
                    th.sticky-position
                      span {{ $t('ui.id') }}
                    th.text-center.sticky-position(width=120)
                      span {{ $t("ui.action") }}
                    th.sticky-position
                      span {{ $t("ui.name") }}
                    th.text-right.sticky-position(width=200)
                      span {{ $t("ui.created_on") }}
                tbody.clusterize-content
                  tr(v-for="(item, index) in filteredFunctionList")
                    td
                      span {{ item.function_id }}
                    td.actions
                      span
                        a.fa.fa-edit.text-primary(href="#" @click="onEdit(item)" :title="$t('ui.edit')")
                      span
                        a.fa.fa-trash.text-danger(href="#" @click="onDelete(item)" :title="$t('ui.delete')")
                    td
                      span {{ item.function_name }}
                    td.text-right
                      span {{ $moment(item.created_on).format("YYYY-MM-DD, HH:mm:ss") }}
      addfunction(@clicked="addFunction" @failed="handleFailed")
      editfunction(ref="editfunction" :functionId="editSelectedId" :functionName="editSelectedName" @clicked="editFunction" @failed="handleFailed")
      deletefunction(ref="deletefunction" :functionId="deleteSelectedId" :functionName="deleteSelectedName" @clicked="deleteFunction" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import addfunction from "@/components/function/addFunction.vue";
import editfunction from "@/components/function/editFunction.vue";
import deletefunction from "@/components/function/deleteFunction.vue";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    addfunction,
    editfunction,
    deletefunction,
    DebounceInput
  },
  data() {
    return {
      filterBy: "id",
      functionList: [],
      functionSearch: "",
      feedback: {
        success: false,
        status: errorTags.request.failed
      },
      editSelectedId: "",
      editSelectedName: "",
      deleteSelectedId: "",
      deleteSelectedName: ""
    };
  },
  computed: {
    filteredFunctionList() {
      return this.functionList.filter(functionInfo => {
        if (this.filterBy == "name") {
          return functionInfo.function_name.toLowerCase().indexOf(this.functionSearch.toLowerCase()) > -1;
        } else {
          return functionInfo.function_id.indexOf(this.functionSearch.toLowerCase()) > -1;
        }
      });
    }
  },
  mounted: function() {
    let url = config.functionListUrl();

    var json = {
      action_by: this.$store.getters.username,
      session_token: this.$store.getters.sessionToken,
      page_id: config.accessRoles.function
    };

    this.$http.post(url, json).then(
      function(response) {
        // Success
        try {
          if (response) {
            if (typeof response.data.status == "string") {
              this.feedback.success = response.data.status == "1";
            } else {
              this.feedback.success = response.data.status == 1;
            }
            this.feedback.status = response.data.statusdesc;
            if (this.feedback.success == true) {
              this.functionList = response.data.tbl_function_list;
            } else {
              this.$helpers.handleFeedback(this.feedback.status);
            }
          }
        } catch (error) {
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      },
      function(response) {
        // Error
        this.feedback.success = false;
        this.feedback.status = errorTags.request.failed;
        this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
      }
    );
  },
  methods: {
    onEdit(e) {
      this.editSelectedId = e.function_id;
      this.editSelectedName = e.function_name;
      this.$refs.editfunction.$refs.editFunction.show();
    },
    onDelete(e) {
      this.deleteSelectedId = e.function_id;
      this.deleteSelectedName = e.function_name;
      this.$refs.deletefunction.$refs.deleteFunction.show();
    },
    addFunction: function(functionId, functionName) {
      let newFunction = {
        function_id: functionId,
        function_name: functionName,
        created_on: new Date()
      };

      this.functionSearch = "";
      this.functionList.unshift(newFunction);
      this.$helpers.showDialog(this.$t("ui.combine.add_function"), this.$t("message.success"), "success");
    },
    editFunction: function(functionId, functionName) {
      this.functionList.filter(function(functionInfo) {
        if (functionInfo.function_id == functionId) {
          functionInfo.function_name = functionName;
        }
      });
      this.$helpers.showDialog(this.$t("ui.combine.edit_function"), this.$t("message.success"), "success");
    },
    deleteFunction: function(functionId) {
      let i = this.functionList
        .map(functionInfo => {
          return functionInfo.function_id;
        })
        .indexOf(functionId);
      this.functionList.splice(i, 1);
      this.$helpers.showDialog(this.$t("ui.combine.delete_function"), this.$t("message.success"), "success");
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
